const accountAggregator = 'https://api.edgrofin.com/account-aggregator/private';

const baseUrls = {
    accountAggregator
};

export default baseUrls;
